import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: ReactNode;
  centered?: boolean;
}

export function SectionHeading({
  eyebrow,
  title,
  description,
  centered = false,
}: SectionHeadingProps) {
  return (
    <div className={cn("space-y-4", centered && "mx-auto max-w-3xl text-center")}>
      <p className="text-xs uppercase tracking-[0.26em] text-muted-foreground">
        {eyebrow}
      </p>
      <h2 className="text-3xl font-semibold tracking-[-0.06em] text-balance md:text-5xl">
        {title}
      </h2>
      {description ? (
        <div className="max-w-3xl text-base leading-8 text-muted-foreground md:text-lg">
          {typeof description === "string" ? <p>{description}</p> : description}
        </div>
      ) : null}
    </div>
  );
}
